module.exports = __webpack_public_path__ + "static/media/check-circle.866f0b99.svg";